import { createContext } from 'react'

export const RequestProfileTabActivitiesContext = createContext()
